import React from 'react';
import PropTypes from 'prop-types';
import style from './Paragraph.module.scss';

function Paragraph({ title = '', text, className = '' }) {
  return (
    <section className={`${style.section} ${className}`}>
      {title !== '' && <h3 className={style.title}>{title}</h3>}

      <p className={style.text}>{text}</p>
    </section>
  );
}

Paragraph.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Paragraph;
